import React from "react";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "../../../components/ui/alert-dialog";
import { Button } from "../../../components/ui/button";
import { MessageCircle } from "lucide-react";

interface QrValidationErrorDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	validationError?: string;
	renderError?: string;
	qrData?: string;
}

export const QrValidationErrorDialog: React.FC<
	QrValidationErrorDialogProps
> = ({ open, onOpenChange, validationError, renderError, qrData }) => {
	const handleContactSupport = () => {
		const errorSummary = [
			validationError && `Validierungsfehler: ${validationError}`,
			renderError && `Rendering-Fehler: ${renderError}`,
		]
			.filter(Boolean)
			.join("\n");

		const qrDataSection = qrData ? `\n\nQR-Daten:\n${qrData}` : "";

		const message = `Hallo Support-Team,

ich habe ein Problem mit der QR-Code Generierung für Sammelrechnungen.

${errorSummary}${qrDataSection}

Vielen Dank für die Hilfe!`;

		if (window.Intercom) {
			window.Intercom("showNewMessage", message);
			onOpenChange(false);
		}
	};

	return (
		<AlertDialog open={open} onOpenChange={onOpenChange}>
			<AlertDialogContent className="max-w-md">
				<AlertDialogHeader>
					<AlertDialogTitle>
						Fehler beim QR-Einzahlungsschein
					</AlertDialogTitle>
					<AlertDialogDescription>
						Es ist ein Fehler beim QR-Einzahlungsschein aufgetreten.
						Bitte kontaktieren Sie den Support. Wir haben bereits
						eine Fehlermeldung mit allen Details für Sie
						vorbereitet.
					</AlertDialogDescription>
				</AlertDialogHeader>

				<AlertDialogFooter className="flex-col sm:flex-row gap-2">
					<Button
						variant="default"
						onClick={handleContactSupport}
						className="gap-2"
						data-testid="contact-support-button"
						aria-label="Support kontaktieren"
					>
						<MessageCircle className="h-4 w-4" />
						Support kontaktieren
					</Button>
					<AlertDialogAction
						onClick={() => onOpenChange(false)}
						data-testid="close-qr-error-dialog"
					>
						Schließen
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};
